import { Injectable, Injector } from '@angular/core';
import { AssetLoadError } from '../../../../cross-team-shared/misc-services/resources/url-request.service';
import { SensorFrame2D } from '../../../../cross-team-shared/state/sensor-renderer-state';
import { ObjectWith } from '../../../../cross-team-shared/types/misc';
import { VideoManifest } from '../../../../team-apis/otterdam/video-manifest';
import { AbstractPerFrameAssetLoadingService } from '../../../shared/asset-loading/abstract-per-frame-asset-loading.service';
import { VideoContentStore } from '../../state/video-content-store';

@Injectable()
export class VideoPerFrameAssetLoadingService extends AbstractPerFrameAssetLoadingService<
  VideoManifest,
  SensorFrame2D
> {
  private store: VideoContentStore;

  constructor(injector: Injector) {
    super(injector);
    this.store = injector.get(VideoContentStore);
  }

  override async loadManifest(manifestUrl: string) {
    if (this.store.state().task.assets_archived_at !== null) {
      throw new AssetLoadError(
        'Asset for this output has been archived. Task input and output answers are still retrievable through task export and API',
      );
    }
    return super.loadManifest(manifestUrl);
  }

  protected getManifestKeys(): Array<keyof VideoManifest> {
    return ['frame_asset_ids'];
  }

  protected getAssetIds(
    manifest: VideoManifest,
    assetIdKey: keyof VideoManifest,
  ) {
    return manifest[assetIdKey];
  }

  protected getNumberOfFrames(manifest: VideoManifest) {
    return manifest.frame_asset_ids.length;
  }

  protected convertToFrame(assets: ObjectWith<string>) {
    return { imageUrl: assets.frame_asset_ids };
  }
}
